import { render, staticRenderFns } from "./ChangeScopesDialog.vue?vue&type=template&id=5794907c&"
import script from "./ChangeScopesDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeScopesDialog.vue?vue&type=script&lang=js&"
import style0 from "./ChangeScopesDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports